import React, { useEffect, useState } from "react";
import Vouchers from "./Vouchers";
import Layout from "../../../app/Layout.js";
import FiltroProyectos from "../../components/Utils/Filtros/FiltroProyectos.js";

const RegistroVouchers = () => {
  const [datosBusqueda, setDatosBusqueda] = useState({});

  const mostrarContenido = () => {
  return <Vouchers id_proyecto={datosBusqueda?.idEvento || 0} />;
};


  return (
    <Layout>
      <div className="registro-vouchers-container">
        <h1>Vouchers</h1>
        <div className="box">
          <div className="box-body">
            <FiltroProyectos
              setValores={setDatosBusqueda}
              //loading={loading}
            />
          </div>
        </div>
        {mostrarContenido()}
      </div>
    </Layout>
  );
};

export default RegistroVouchers;
